// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 선택된 메뉴 항목 스타일 - 반투명 배경색 적용 (너비 조정) */
.ant-menu-item-selected {
  position: relative;
  background-color: transparent !important;
}

/* 선택된 메뉴 항목 배경 커스텀 */
.ant-menu-item-selected::before {
  content: '';
  position: absolute;
  top: 0;
  left: 5px;
  right: 5px;
  bottom: 0;
  background-color: rgba(24, 144, 255, 0.2);
  border-radius: 2px;
  z-index: -1;
}

/* 선택된 메뉴 항목의 텍스트 색상 */
.ant-menu-item-selected span {
  color: inherit !important;
}

/* 메뉴 항목 호버 효과 - 선택된 메뉴 항목과 동일한 스타일 적용 */
.ant-menu-item:hover {
  position: relative;
  background-color: transparent !important;
}

/* 메뉴 항목 호버 배경 커스텀 */
.ant-menu-item:hover::before {
  content: '';
  position: absolute;
  top: 0;
  left: 5px;
  right: 5px;
  bottom: 0;
  background-color: rgba(24, 144, 255, 0.1);
  border-radius: 2px;
  z-index: -1;
}

/* 선택된 메뉴 그룹 스타일 */
.ant-menu-submenu-selected > .ant-menu-submenu-title {
  color: #1890ff !important;
  font-weight: bold !important;
}

/* 메뉴 아이콘 스타일 */
.ant-menu-item .anticon {
  margin-right: 10px;
}

/* 메뉴 트리 구조 라인 스타일 제거 */
.ant-menu-inline .ant-menu-item::after {
  border-right: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,SAAS;EACT,yCAAyC;EACzC,kBAAkB;EAClB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,SAAS;EACT,yCAAyC;EACzC,kBAAkB;EAClB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,6BAA6B;AAC/B","sourcesContent":["/* 선택된 메뉴 항목 스타일 - 반투명 배경색 적용 (너비 조정) */\n.ant-menu-item-selected {\n  position: relative;\n  background-color: transparent !important;\n}\n\n/* 선택된 메뉴 항목 배경 커스텀 */\n.ant-menu-item-selected::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 5px;\n  right: 5px;\n  bottom: 0;\n  background-color: rgba(24, 144, 255, 0.2);\n  border-radius: 2px;\n  z-index: -1;\n}\n\n/* 선택된 메뉴 항목의 텍스트 색상 */\n.ant-menu-item-selected span {\n  color: inherit !important;\n}\n\n/* 메뉴 항목 호버 효과 - 선택된 메뉴 항목과 동일한 스타일 적용 */\n.ant-menu-item:hover {\n  position: relative;\n  background-color: transparent !important;\n}\n\n/* 메뉴 항목 호버 배경 커스텀 */\n.ant-menu-item:hover::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 5px;\n  right: 5px;\n  bottom: 0;\n  background-color: rgba(24, 144, 255, 0.1);\n  border-radius: 2px;\n  z-index: -1;\n}\n\n/* 선택된 메뉴 그룹 스타일 */\n.ant-menu-submenu-selected > .ant-menu-submenu-title {\n  color: #1890ff !important;\n  font-weight: bold !important;\n}\n\n/* 메뉴 아이콘 스타일 */\n.ant-menu-item .anticon {\n  margin-right: 10px;\n}\n\n/* 메뉴 트리 구조 라인 스타일 제거 */\n.ant-menu-inline .ant-menu-item::after {\n  border-right: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
